// 5.D iter 4: shared URL safety boundary check, accessible from BOTH the
// studio module (presigned PUT / image URLs from authoring) and the viewer
// module (public floorplan GET, future endpoints). Rejects
// javascript:/data:/non-parsable so they can never flow into anchor.href,
// window.open(), <img src>, etc.
//
// Previously this lived in src/studio/url-safety.ts and was unreachable
// from src/api/client.ts (cross-import would create a layering inversion
// — viewer must not depend on studio code). Promoted here.
export function isSafeHttpUrl(value: unknown): value is string {
  if (typeof value !== 'string' || value.length === 0) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}
